<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <div>
          <b-card-title>{{ `รายชื่อ Downline ของตัวแทน (${total})` }}</b-card-title>
        </div>
      </b-card-header>
      <hr class="m-0">
      <b-card-body>
        <b-row align-h="center">
          <b-col>
            <b-input-group class="input-group-merge">
              <b-form-input
                v-model="search"
                type="search"
                :placeholder="`ชื่อตัวแทน`"
              />
              <b-input-group-append is-text>
                <feather-icon
                  icon="SearchIcon"
                  class="text-muted"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
      <!-- Table -->
      <b-table
        :items="dataList"
        :fields="fields"
        :busy="isFetching"
        responsive
        show-empty
        hover
      >
        <template #cell(id)="data">
          <b-button
            variant="flat-primary"
            @click="onClick(data)"
          >
            <feather-icon icon="LogInIcon" />
            เข้าใข้งานระบบหลังบ้านตัวแทน
          </b-button>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>
        <template #empty="">
          <p class="text-center text-muted">
            ไม่มี Downline
          </p>
        </template>
      </b-table>
      <!-- pagination -->
      <b-card-footer>
        <b-row class="">
          <b-col md="4">
            <page-limit-select
              :value="limit"
              @update="onLimitChange"
            />
          </b-col>
          <b-col>
            <pagination-input
              :per-page="limit"
              :total="total"
              @update="(val) => (currentPage = val)"
            />
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <agent-link-modal />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    AgentLinkModal: () => import('./AgentLinkModal.vue'),
  },
  data() {
    return {
      currentPage: 1,
      selectedLimit: 20,
      search: '',
      onSearchTimeout: null,
      fields: [
        {
          key: 'name',
          label: 'ชื่อตัวแทน',
          thStyle: {
            minWidth: '200px',
          },
        },
        {
          key: 'web',
          label: 'เว็บไซต์เกม',
          thStyle: {
            minWidth: '100px',
          },
        },
        {
          key: 'commission',
          label: '% รายได้จากค่าธรรมเนียม',
          thStyle: {
            minWidth: '150px',
          },
        },
        {
          key: 'id',
          label: '',
          thStyle: {
            minWidth: '200px',
          },
        },
      ],
    }
  },
  computed: {
    ...mapState({
      isFetching: (state) => state.agent.isGettingAgents,
    }),
    ...mapGetters(['agents']),
    dataList() {
      return []
    },
    pagination() {
      return {
        itemsPerPage: 0,
        totalItems: 0,
      }
    },
    limit() {
      return this.pagination.itemsPerPage
    },
    total() {
      return this.pagination.totalItems
    },
  },
  watch: {
    currentPage(val) {
      if (val) {
        this.$addPageToLocation(val)
        this.fetchData()
      }
    },
    search() {
      this.delaySearch()
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions([]),
    fetchData() {},
    delaySearch() {
      clearTimeout(this.onSearchTimeout)
      this.onSearchTimeout = setTimeout(this.fetchData, 800)
    },
    onLimitChange(limit) {
      if (limit) {
        this.selectedLimit = limit
        this.fetchData()
      }
    },
  },
}
</script>
